import { Typography } from "@mui/material";
import Libelle from "../../_i18n/fr.json";
import Layout from "../../components/Layout";
import {
  getUsername,
  isAuthenticated,
} from "../../services/Authentification/authentification";
import Dashboard from "./Dashboard";

function DashboardPage() {
  const username = getUsername();
  if (isAuthenticated() && username) {
    return (
      <Layout title={Libelle.pageDashboard.titre}>
        <Dashboard />
      </Layout>
    );
  }
  // TODO afficher vraie erreur
  return (
    <Layout>
      <Typography>Erreur</Typography>
    </Layout>
  );
}

export default DashboardPage;
